import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    mode: 'light',  // Keeping light mode as per your preference
    primary: {
      main: '#8f7944',  // Dark Green (Primary)
      light: '#bf8f54', // Warm Beige
      dark: '#bf8f54',  // Deep Olive
      contrastText: '#efeee7', // Off-White for text on buttons
    },
    secondary: {
      main: '#8f7944',  // Burnt Orange
      light: '#d9d9d9', // Light Gray
      dark: '#8f7944',  // Muted Gold
      contrastText: '#ffffff',
    },
    background: {
      default: '#48594d', // Off-White background
      paper: '#e4e2dd',   // Soft Gray for cards
    },
    surface: {
      main: '#bf8f54',
      hover: '#bf8f54', // Light Gray hover effect
    },
    text: {
      primary: '#1f261c',  // Deep Olive for main text
      secondary: '#48594d', // Dark Green for subtitles
    },
  },
  typography: {
    fontFamily: '"Roboto", "Arial", sans-serif', // Keeping clean, modern font
    h1: {
      fontSize: '2.5rem',
      fontWeight: 500,
      letterSpacing: '-0.01562em',
      color: '#1f261c', // Deep Olive
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 500,
      color: '#48594d', // Dark Green
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 500,
      color: '#8f7944', // Muted Gold
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 500,
      color: '#8f7944', // Burnt Orange
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 500,
      color: '#bf8f54', // Warm Beige
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 500,
      color: '#48594d', // Dark Green
    },
    h7: {
      fontSize: '4rem',
      fontWeight:500,
      color: '#efeee7'
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.5,
      color: '#1f261c', // Deep Olive
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.43,
      color: '#48594d', // Dark Green
    },

  },
  shape: {
    borderRadius: 8,  // Keeping rounded corners
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
          padding: '8px 16px',
          fontWeight: 500,
        },
        contained: {
          backgroundColor: '#a6671b', // Burnt Orange for buttons
          color: '#ffffff',
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: '#8f7944', // Muted Gold on hover
            boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          backgroundColor: '#bf8f54', // Soft Gray for cards
          boxShadow: '0px 2px 8px rgba(0,0,0,0.05)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          backgroundColor: '#e4e2dd', // Off-White for general background
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#e4e2dd', // Dark Green for the navbar
          color: '#efeee7', // Off-White text
          boxShadow: '0px 2px 8px rgba(0,0,0,0.05)',
          borderBottom: '1px solid rgba(0,0,0,0.1)',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#e4e2dd', // Deep Olive for sidebar
          color: '#efeee7', // Off-White text
          borderRight: '1px solid rgba(0,0,0,0.05)',
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          paddingLeft: 24,
          paddingRight: 24,
        },
      },
    },
    MuiGrid: {
      styleOverrides: {
        container: {
          marginTop: 0,
        },
      },
    },
  },
});
